import React, { Component } from "react";
import { Tag } from "antd";

const { CheckableTag } = Tag;

class MyTag extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = checked => {
    const { handleChange, uuid } = this.props;
    handleChange(uuid);
  };

  render() {
    return <CheckableTag {...this.props} onChange={this.handleChange} />;
  }
}
export default MyTag;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/MyTag.js